













import Vue, { PropType } from "vue";
import fetch from "cross-fetch";

export interface PaypalCustomCardFieldsData {
  isProcessing: boolean;
}

export interface GoldAutochargePaypalSubmitCardInformationProps {
  purchaseApiUrl: string;
  completedUrl: string;
  cancelCompletedUrl: string;
  errorUrl: string;
  csrfToken: string;
  updateIsBusy: any;
  isUseSettings: boolean;
  isAllChecked: boolean;
  isValid: boolean;
  hostedFields: any;
}

export default Vue.extend({
  name: "vc-gold-autocharge-paypal-submit-card-information",
  props: {
    purchaseApiUrl: {
      type: String as PropType<
        GoldAutochargePaypalSubmitCardInformationProps["purchaseApiUrl"]
      >,
      default: ""
    },
    completedUrl: {
      type: String as PropType<
        GoldAutochargePaypalSubmitCardInformationProps["completedUrl"]
      >,
      default: ""
    },
    cancelCompletedUrl: {
      type: String as PropType<
        GoldAutochargePaypalSubmitCardInformationProps["cancelCompletedUrl"]
      >,
      default: ""
    },
    errorUrl: {
      type: String as PropType<
        GoldAutochargePaypalSubmitCardInformationProps["errorUrl"]
      >,
      default: ""
    },
    csrfToken: {
      type: String as PropType<
        GoldAutochargePaypalSubmitCardInformationProps["csrfToken"]
      >,
      default: ""
    },
    //mutationsToProps
    updateIsBusy: {
      type: Function as PropType<
        GoldAutochargePaypalSubmitCardInformationProps["updateIsBusy"]
      >,
      default: () => {}
    },
    isUseSettings: {
      type: Boolean as PropType<
        GoldAutochargePaypalSubmitCardInformationProps["isUseSettings"]
      >,
      default: true
    },
    isAllChecked: {
      type: Boolean as PropType<
        GoldAutochargePaypalSubmitCardInformationProps["isAllChecked"]
      >,
      default: false
    },
    isValid: {
      type: Boolean as PropType<
        GoldAutochargePaypalSubmitCardInformationProps["isAllChecked"]
      >,
      default: false
    },
    hostedFields: {
      type: Object as PropType<
        GoldAutochargePaypalSubmitCardInformationProps["hostedFields"]
      >,
      default: () => ({})
    }
  },
  data(): PaypalCustomCardFieldsData {
    return {
      isProcessing: false
    };
  },
  computed: {
    isReadySubmit(): boolean {
      // 処理中の場合
      if (this.isProcessing) return false;
      // 規約に同意していない場合
      if (!this.isAllChecked) return false;
      // 「利用する」の時、入力内容が不正である場合
      if (this.isUseSettings && !this.isValid) return false;

      return true;
    }
  },
  methods: {
    confirmSubmit(event: object) {
      this.isProcessing = true;
      this.updateIsBusy(true);
      if (this.isUseSettings) {
        this.submitPaypal(event);
      } else {
        this.noUseSettings();
      }
    },
    submitPaypal(event: any) {
      const purchaseApiUrl = this.purchaseApiUrl;
      const completedUrl = this.completedUrl;
      const errorUrl = this.errorUrl;

      event.preventDefault();
      this.hostedFields
        .submit({
          vault: true
        })
        .then((payload: any) => {
          // Make a call to capture the order (payload.orderId) here
          return fetch(purchaseApiUrl, {
            method: "PUT",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "x-csrf-token": this.csrfToken
            },
            body: JSON.stringify({
              orderId: payload.orderId
            })
          })
            .then(response => {
              if (!response.ok) {
                throw new Error(`${response.status} ${response.statusText}`);
              }
              return response.json();
            })
            .then(data => {
              location.href = completedUrl;
            })
            .catch((error: any) => {
              location.href = errorUrl + "?type=system_error";
            });
        })
        .catch((error: any) => {
          location.href = errorUrl + "?type=system_error";
          this.isProcessing = false;
          this.updateIsBusy(false);
        });
    },
    noUseSettings() {
      // 削除API実装後に検証
      fetch(this.purchaseApiUrl, {
        method: "DELETE",
        headers: {
          "x-csrf-token": this.csrfToken
        }
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          location.href = this.cancelCompletedUrl;
        })
        .catch(error => {
          location.href = this.errorUrl + "?type=system_error";
          this.isProcessing = false;
          this.updateIsBusy(false);
        });
    }
  }
});
